import React, { useRef, useEffect, useState, useContext } from 'react';
import Select from "react-select";
import { Context } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import ApiAlunos from '../services/alunoService';
import ApiEventos from '../services/eventoService';
import ApiMunicipios from '../services/municipioService';
import ValorMonetario from '../components/ValorMonetario';
import RangeSelect from '../components/RangeSelect';
import DivisaoSelect from '../components/DivisaoSelect';
import FormaPagamento from '../components/FormaPagamento';
import useEventoInscricao from "../hooks/useEventoInscricao";

const EventoInscricaoDetalhes = ({ evento }) => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();
    const { handleLogout } = useContext(Context);

    const boxPedidoRef = useRef(null);
    const isProcessingRef = useRef(false);

    const [eventoId, setEventoId] = useState(null);
    const [dadosAtleta, setDadosAtleta] = useState([]);
    const [dadosGyeorugi, setDadosGyeorugi] = useState(null);
    const [opcoesGyeorugi, setOpcoesGyeorugi] = useState([]);
    const [dadosPoomsae, setDadosPoomsae] = useState([]);
    const [inscricao, setInscricao] = useState([]);
    const [inscritoGyeorugi, setInscritoGyeorugi] = useState(0);
    const [inscritoPoomsae, setInscritoPoomsae] = useState(0);
    const [tecnicos, setTecnicos] = useState([]);
    const [tecnico, setTecnico] = useState(null);
    const [peso, setPeso] = useState(null);
    const [altura, setAltura] = useState(null);
    const [divisaoCodigo, setDivisaoCodigo] = useState(null);
    const [modalidade, setModalidade] = useState(null);
    const [pedido, setPedido] = useState(null);
    const [boletoGyeorugi, setBoletoGyeorugi] = useState(null);
    const [boletoPoomsae, setBoletoPoomsae] = useState(null);
    const [pagamentoPoomsae, setPagamentoPoomsae] = useState(0);
    const [pagamentoGyeorugi, setPagamentoGyeorugi] = useState(0);
    const [isCheckedGyeorugi, setIsCheckedGyeorugi] = useState(false);
    const [isCheckedPoomsae, setIsCheckedPoomsae] = useState(false);
    const [listaMunicipios, setListaMunicipios] = useState([]);
    const [municipio, setMunicipio] = useState('');

    const { valorFinal } = useEventoInscricao(user, evento, token);

    const texto = evento.tipoEvento !== 3 ? 'Gerar Boleto' : 'Realizar Inscrição';

    const handleToggleGyeorugi = () => {
        if (divisaoCodigo && tecnico && (peso || altura)) {
            setIsCheckedGyeorugi((prevState) => !prevState);
            return;
        }

        Swal.fire(
            "Atenção",
            "Preencha para se inscrever no Gyeorugi informe divisão, técnico e peso/altura!",
            "warning"
        );
    };

    const handleTogglePoomsae = () => {
        if (modalidade) {
            setIsCheckedPoomsae((prevState) => !prevState);
            return;
        }

        Swal.fire(
            "Atenção",
            "Preencha para se inscrever no Poomsae informe a modalidade!",
            "warning"
        );
    };

    const handleChangeDivisao = (novaDivisao) => {
        setDivisaoCodigo(novaDivisao);
        setPeso(null);
        setAltura(null);
        setIsCheckedGyeorugi(false);

        const divisaoSelecionada = opcoesGyeorugi.find(
            (item) => item.divisoesCodigos === novaDivisao
        );

        if (!divisaoSelecionada) {
            return;
        }

        setDadosGyeorugi((prev) => ({
            ...prev,
            rangePeso: divisaoSelecionada.rangePeso,
            rangeAltura: divisaoSelecionada.rangeAltura,
            estilo: divisaoSelecionada.estilo,
            divisoesCodigosSelecionado: divisaoSelecionada.divisoesCodigos,
        }));
    };

    const obterDadosInscricao = async (userId, idEvento) => {
        if (idEvento === undefined) {
            return;
        }

        try {
            const response = await ApiEventos.dadosInscricao(userId, idEvento, token);

            if (response.statusRetorno === 401) {
                handleLogout();
                navigate('/');
                return;
            }

            let pedidoGyeorugiId = 0;
            let pedidoPoomsaeId = 0;

            if (response.data?.gyeorugi && Array.isArray(response.data.gyeorugi)) {
                setInscritoGyeorugi(response.data.gyeorugi.length);
            }

            if (response.data?.poomsae && Array.isArray(response.data.poomsae)) {
                setInscritoPoomsae(response.data.poomsae.length);
            }

            if (response.data?.pedidoGyeorugi) {
                if (response.data.pedidoGyeorugi.status === 1) {
                    setPagamentoPoomsae('1');
                } else {
                    setBoletoGyeorugi(response.data.pedidoGyeorugi.boleto_pdf);
                }

                pedidoGyeorugiId = response.data.pedidoGyeorugi.id;
            }

            if (response.data?.pedidoPoomsae) {
                if (response.data.pedidoPoomsae.status === 1) {
                    setPagamentoPoomsae('1');
                } else {
                    setBoletoPoomsae(response.data.pedidoPoomsae.boleto_pdf);
                }

                pedidoPoomsaeId = response.data.pedidoPoomsae.id;
            }

            if ((pedidoGyeorugiId === pedidoPoomsaeId) && (pedidoGyeorugiId > 0)) {
                setBoletoGyeorugi(null);
                setBoletoPoomsae(null);

                if (response.data.pedidoGyeorugi.status === 1) {
                    setPagamentoGyeorugi('1');
                    setPagamentoPoomsae('1');
                } else {
                    setPedido(response.data.pedidoGyeorugi);
                }
            }
        } catch (error) {
            console.error("Erro ao obter dados de inscrição:", error);
        }
    };

    const obterDadosAtleta = async (userId, tipoEvento) => {
        try {
            const response = await ApiAlunos.dadosInscricao(userId, tipoEvento, token);

            if (response.statusRetorno === 401) {
                handleLogout();
                navigate('/');
                return;
            }

            const atleta = response.data?.atleta?.[0] ?? {};
            const gyeorugi = response.data?.gyeorugi ?? [];

            const divisoesCodigos = gyeorugi
                .map((item) => item.divisoesCodigos)
                .filter(Boolean)
                .join('||');

            const dadosGyeorugiFormatado = gyeorugi.length > 0
                ? {
                    ...gyeorugi[0],
                    divisoesCodigos,
                }
                : null;

            setDadosAtleta(atleta);
            setMunicipio(atleta.municipio_id);
            setOpcoesGyeorugi(gyeorugi);
            setDadosGyeorugi(dadosGyeorugiFormatado);
            setDadosPoomsae(response.data?.poomsae ?? []);
            setTecnicos(response.data?.tecnicos ?? []);
            setTecnico(gyeorugi[0]?.professorId || null);
        } catch (error) {
            console.error("Erro ao obter dados do atleta:", error);
        }
    };

    const handlepagamento = async () => {
        if (isProcessingRef.current) {
            return;
        }

        isProcessingRef.current = true;

        const data = {
            usuarioId: user.id,
            alunoId: dadosAtleta.id,
            eventoId: eventoId,
            tecnicoId: tecnico,
            peso: peso,
            altura: altura,
            divisaoCodigo: divisaoCodigo,
            gyeorugi: isCheckedGyeorugi,
            modalidade: modalidade,
            poomsae: isCheckedPoomsae,
            gerarPedido: evento.tipoEvento == 3 ? false : true,
            municipioId: municipio
        };

        const dataAluno = {
            id: dadosAtleta.id,
            user_id: dadosAtleta.user_id,
            name: dadosAtleta.nome,
            email: dadosAtleta.email,
            municipio_id: municipio,
        };

        try {
            if (evento.tipoEvento === 3) {
                const resp = await ApiAlunos.save(dataAluno, token);

                if (resp.statusRetorno === 401) {
                    handleLogout();
                    navigate('/');
                    return;
                }
            }

            const response = await ApiEventos.pagamento(data, token);

            if (response.statusRetorno === 401) {
                handleLogout();
                navigate('/');
                return;
            }

            if (response.status === 'error') {
                Swal.fire({
                    title: 'Houve um erro ao Processar a sua inscrição!',
                    text: response.message,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });

                return;
            }

            const pedidoInscricao = response.pedido;

            setPedido(pedidoInscricao);
            setInscricao(response.inscricao);

            setTimeout(() => {
                boxPedidoRef.current?.scrollIntoView({ behavior: "smooth" });
            }, 100);
        } catch (error) {
            Swal.fire({
                title: 'Erro ao processar a inscrição!',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        } finally {
            isProcessingRef.current = false;
        }
    };

    const obterListaMunicipios = async () => {
        const response = await ApiMunicipios.listar();

        if (response.statusRetorno !== 200) {
            Swal.fire({
                title: 'Erro ao carregar Municipios!',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Ok'
            });

            return;
        }

        setListaMunicipios(response.data);
    };

    useEffect(() => {
        if (user?.id) {
            if (user.status !== 'Ativo') {
                navigate('/');
                return;
            }

            obterDadosAtleta(user.id, evento.tipoEvento);
            obterDadosInscricao(user.id, evento.id);
            setEventoId(evento.id);
        }
    }, [evento?.id, user?.id]);

    useEffect(() => {
        if (!divisaoCodigo || !tecnico || (!peso && !altura)) {
            setIsCheckedGyeorugi(false);
        }
    }, [divisaoCodigo, tecnico, peso, altura]);

    useEffect(() => {
        if (!modalidade) {
            setIsCheckedPoomsae(false);
        }
    }, [modalidade]);

    useEffect(() => {
        obterListaMunicipios();
    }, []);

    return (
        <>
            <div className="container z-9">
                {evento.tipoEvento === 3 &&
                    <div className="row">
                        <div className="col-md-4">
                            <label>Município *</label>
                            <Select
                                options={
                                    listaMunicipios.map((m) => ({
                                        value: m.id,
                                        label: m.municipio,
                                    }))
                                }
                                value={
                                    listaMunicipios
                                        .map((m) => ({ value: m.id, label: m.municipio }))
                                        .find((opt) => opt.value === municipio) || null
                                }
                                onChange={(selected) => setMunicipio(selected?.value || '')}
                                placeholder="Digite para buscar..."
                                isSearchable
                                noOptionsMessage={() => "Nenhum município encontrado"}
                            />
                        </div>
                    </div>
                }

                <div className="row">
                    {evento.gyeorugi === 'sim' && dadosGyeorugi && (
                        <div className="col-xl-4 col-md-6 mb-sm-30 fadeInRight">
                            <div className="de_pricing-table type-2">
                                <div className="d-head">
                                    <h3>Gyeorugi</h3>
                                </div>

                                <div className="d-price">
                                    <h4 className="opt-1">
                                        <ValorMonetario valor={valorFinal} />
                                    </h4>
                                </div>

                                <div className="spacer-5"></div>

                                {inscritoGyeorugi === 0 &&
                                    <>
                                        <div className="d-group">
                                            <ul className="d-list">
                                                <li>
                                                    Graduação<br />
                                                    {dadosGyeorugi.faixa}
                                                </li>

                                                <li>
                                                    Divisão<br />
                                                    <DivisaoSelect
                                                        divisao={dadosGyeorugi.divisoesCodigos}
                                                        value={divisaoCodigo || ''}
                                                        onChange={handleChangeDivisao}
                                                    />
                                                </li>

                                                <li>
                                                    Técnico<br />

                                                    {tecnicos && tecnicos.length > 0 ? (
                                                        <select
                                                            className="form-control"
                                                            value={tecnico || ''}
                                                            onChange={(e) => setTecnico(e.target.value)}
                                                        >
                                                            <option value="">::Selecione::</option>

                                                            {tecnicos.map((option) => (
                                                                <option key={option.id} value={option.id}>
                                                                    {option.nome}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    ) : (
                                                        <p style={{ color: 'red', marginTop: '5px' }}>
                                                            ⚠️ Sua academia precisa informar pelo menos um técnico para você realizar a sua inscrição.
                                                        </p>
                                                    )}
                                                </li>

                                                {dadosGyeorugi.rangePeso &&
                                                    <li>
                                                        Peso<br />
                                                        <RangeSelect
                                                            range={dadosGyeorugi.rangePeso}
                                                            value={peso || ''}
                                                            onChange={setPeso}
                                                            type="Kg"
                                                        />
                                                    </li>
                                                }

                                                {dadosGyeorugi.rangeAltura &&
                                                    <li>
                                                        Altura<br />
                                                        <RangeSelect
                                                            range={dadosGyeorugi.rangeAltura}
                                                            value={altura || ''}
                                                            onChange={setAltura}
                                                            type="Cm"
                                                        />
                                                    </li>
                                                }
                                            </ul>
                                        </div>

                                        {divisaoCodigo && tecnico && (peso || altura) && (
                                            <div className="d-action">
                                                <input
                                                    className={`switch ${isCheckedGyeorugi ? 'checked' : 'unchecked'}`}
                                                    type="checkbox"
                                                    checked={isCheckedGyeorugi}
                                                    onChange={handleToggleGyeorugi}
                                                /> Quero Participar
                                            </div>
                                        )}
                                    </>
                                }

                                {inscritoGyeorugi !== 0 &&
                                    <div className="d-group">
                                        <ul className="d-list">
                                            <li>Inscrição Realizada!</li>
                                        </ul>
                                    </div>
                                }

                                {pagamentoGyeorugi !== 0 &&
                                    <div className="d-group">
                                        <ul className="d-list">
                                            <li>Pagamento Realizado!</li>
                                        </ul>
                                    </div>
                                }

                                {boletoGyeorugi &&
                                    <div className="d-group">
                                        <ul className="d-list">
                                            <a href={boletoGyeorugi} target="_blank" rel="noreferrer" className="btn-main color-2">
                                                Ver Boleto
                                            </a>
                                        </ul>
                                    </div>
                                }
                            </div>
                        </div>
                    )}

                    {evento.poomsae === 'sim' &&
                        <div className="col-xl-4 col-md-6 mb-sm-30 fadeInRight">
                            <div className="de_pricing-table type-2">
                                <div className="d-head">
                                    <h3>Poomsae</h3>
                                </div>

                                <div className="d-price">
                                    <h4 className="opt-1">
                                        <ValorMonetario valor={valorFinal} />
                                    </h4>
                                </div>

                                <div className="spacer-5"></div>

                                {inscritoPoomsae === 0 &&
                                    <>
                                        <div className="d-group">
                                            <ul className="d-list">
                                                <li>{dadosPoomsae.descricao}</li>

                                                <li>
                                                    Modalidade<br />
                                                    <select
                                                        className="form-control"
                                                        value={modalidade || ''}
                                                        onChange={(e) => setModalidade(e.target.value)}
                                                    >
                                                        <option value="">::Selecione::</option>
                                                        <option value="Individual">Individual</option>
                                                        <option value="FreeStyle">Free Style</option>
                                                    </select>
                                                </li>
                                            </ul>
                                        </div>

                                        {modalidade && (
                                            <div className="d-action">
                                                <input
                                                    className={`switch ${isCheckedPoomsae ? 'checked' : 'unchecked'}`}
                                                    type="checkbox"
                                                    checked={isCheckedPoomsae}
                                                    onChange={handleTogglePoomsae}
                                                /> Quero Participar
                                            </div>
                                        )}
                                    </>
                                }

                                {inscritoPoomsae !== 0 &&
                                    <div className="d-group">
                                        <ul className="d-list">
                                            <li>Inscrição Realizada!</li>
                                        </ul>
                                    </div>
                                }

                                {pagamentoPoomsae !== 0 &&
                                    <div className="d-group">
                                        <ul className="d-list">
                                            <li>Pagamento Realizado!</li>
                                        </ul>
                                    </div>
                                }

                                {boletoPoomsae &&
                                    <div className="d-group">
                                        <ul className="d-list">
                                            <a href={boletoPoomsae} target="_blank" rel="noreferrer" className="btn-main color-2">
                                                Ver Boleto
                                            </a>
                                        </ul>
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    {(isCheckedGyeorugi || isCheckedPoomsae) &&
                        <div className="col-xl-4 col-md-6 mb-sm-30 fadeInRight">
                            <div className="de_pricing-table type-2">
                                <div className="d-head">
                                    <h3>{texto}</h3>
                                </div>

                                <div className="d-price">
                                    <h4 className="opt-1">Olá <span>{user.name}</span>, tudo bem?</h4>
                                    <h4 className="opt-1">Você está se inscrevendo nas seguintes modalidades:</h4>
                                </div>

                                <div className="spacer-5"></div>
                                <div className="spacer-5"></div>

                                <div className="d-group">
                                    <ul className="d-list">
                                        {isCheckedGyeorugi &&
                                            <li>Gyeorugi</li>
                                        }

                                        {isCheckedPoomsae &&
                                            <li>Poomsae</li>
                                        }
                                    </ul>
                                </div>

                                <div className="d-action">
                                    {!pedido &&
                                        <input
                                            type="button"
                                            value={
                                                evento.tipoEvento != 3
                                                    ? 'Efetuar Pagamento'
                                                    : 'Realizar Inscrição'
                                            }
                                            className="btn-main color-2"
                                            onClick={handlepagamento}
                                        />
                                    }

                                    {(evento.tipoEvento !== 3 && pedido !== null) &&
                                        <>
                                            <h4 className="opt-1"><span>Boleto gerado com sucesso!</span></h4>
                                            <p>* Seu boleto e QRCODE para pagamento estão disponíveis abaixo!</p>
                                        </>
                                    }

                                    {(evento.tipoEvento === 3 && pedido !== null) &&
                                        <>
                                            <h4 className="opt-1"><span>Inscrição realizada com sucesso!</span></h4>
                                        </>
                                    }

                                    {evento.tipoEvento != 3 &&
                                        <p>* Sua inscrição só será confirmado após a confirmação do pix ou da compensação do boleto!</p>
                                    }
                                </div>
                            </div>
                        </div>
                    }

                    {(pedido !== null && pedido?.status !== 1 && evento.tipoEvento !== 3) &&
                        <div className="row mt-5" id="boxPedido" ref={boxPedidoRef}>
                            <br /><br />
                            <div className="col-xl-12 col-md-6 mb-sm-30 fadeInRight mb-5">
                                <div className="de_pricing-table type-2">
                                    <FormaPagamento pedido={pedido} />
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    );
};

export default EventoInscricaoDetalhes;